/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Dok_S2Inputs */

const en_tut_dok_s2 = /** @type {(inputs: Tut_Dok_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Give it a title and write. Turn on **Editor visual** if you prefer editing like a word processor; **Sunting** and **Pratinjau** swap at any time.`)
};

const id_tut_dok_s2 = /** @type {(inputs: Tut_Dok_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isi judulnya, lalu tulis. Hidupkan **Editor visual** kalau Anda lebih suka menyunting seperti di pengolah kata; **Sunting** dan **Pratinjau** bisa ditukar kapan saja.`)
};

/**
* | output |
* | --- |
* | "Give it a title and write. Turn on **Editor visual** if you prefer editing like a word processor; **Sunting** and **Pratinjau** swap at any time." |
*
* @param {Tut_Dok_S2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_dok_s2 = /** @type {((inputs?: Tut_Dok_S2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Dok_S2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_dok_s2(inputs)
	return en_tut_dok_s2(inputs)
});